export const GET_MEMBER_DETAILS = 'GET_MEMBER_DETAILS'
export const GET_MEMBER_ADDRESSES = 'GET_MEMBER_ADDRESSES'
export const GET_MEMBER_TRANSACTIONS = 'GET_MEMBER_TRANSACTIONS'
export const GET_MEMBER_TRANSACTION_DRAFTS = 'GET_MEMBER_TRANSACTION_DRAFTS'
export const GET_MEMBER_TRANSACTION_DETAILS = 'GET_MEMBER_TRANSACTION_DETAILS'
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
